import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Quiet empty state for document-driven workflows: what's missing, why, and one action. */ export function SpecraEmptyState({ action, className, description, framed = false, icon, size = 'default', title, ...props }) {
    const frame = framed && 'rounded-[var(--radius-lg)] border border-dashed border-[color:var(--border-dashed)]';
    if (size === 'compact') {
        // Inline text flow, so a long description wraps as a sentence rather than
        // dropping onto its own line; the body size is set here so the action inherits it.
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('px-[var(--space-4)] py-[var(--space-3)] text-left text-[length:var(--fs-ui-body)] leading-snug', frame, className),
            "data-size": "compact",
            ...props,
            children: [
                /*#__PURE__*/ _jsx(SpecraText, {
                    className: "font-medium",
                    size: "body-ui",
                    children: title
                }),
                description ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        ' ',
                        /*#__PURE__*/ _jsx(SpecraText, {
                            size: "body-ui",
                            tone: "muted",
                            children: description
                        })
                    ]
                }) : null,
                action ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        " ",
                        action
                    ]
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex flex-col items-center px-6 py-10 text-center', frame, className),
        ...props,
        children: [
            icon ? /*#__PURE__*/ _jsx(SpecraIconTile, {
                className: "mb-3",
                size: "lg",
                children: icon
            }) : null,
            /*#__PURE__*/ _jsx(SpecraHeading, {
                size: "sm",
                children: title
            }),
            description ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                className: "mt-1 max-w-md",
                size: "caption",
                tone: "muted",
                children: description
            }) : null,
            action ? /*#__PURE__*/ _jsx("div", {
                className: "mt-4",
                children: action
            }) : null
        ]
    });
}
